export default __webpack_public_path__ + "static/media/Group.cc42bfe5.svg";